<template>
  <div>
    <div class="jumbotron">
      <div class="mask"></div>
      <b-row class="mx-auto py-5 text-left" style="max-width: 1460px">
        <b-col sm="12">
          <h1 class="text-white">Compliance</h1>
        </b-col>
      </b-row>
    </div>

    <b-row class="m-2 mx-auto" style="max-width: 1460px">
      <b-col lg="12" class="text-left">
        <p>
          Affinché la piattaforma possa essere veramente utile e funzionale è importante osservare un paio di regole.
        </p>
        <p>Per coloro che hanno bisogno di traduzioni (genericamente: “Organizzazioni”):</p>

        <h4>Formati dei testi</h4>
        <p>
          I testi caricati nei formati doc, docx o odt verranno pretradotti in automatico e corretti da una persona
          madrelingua. Se il tool utilizzato non offre la lingua richiesta, questa verrà tradotta dalla persona
          madrelingua. Si raccomanda se possibile di seguire questa via perché più rapida e meno onerosa per le persone
          e per il sistema. I formati pdf o jpg non possono essere pretradotti per ragioni tecniche e pertanto, dovendo
          essere tradotti per intero da una persona madrelingua, sono più laboriosi e richiedono un tempo leggermente
          maggiore. La piattaforma offre anche la possibilità del cosiddetto Text-to-speech, vale a dire la riproduzione
          audio di un testo, un messaggio, un’avvertenza, ecc. per i migranti non alfabetizzati. Infine, sarà
          disponibile entro breve una funzione speech-to-speech. Per fornire questa funzione è stata fatta una selezione
          tra gli strumenti tecnologici attualmente più avanzati. Le lingue disponibili in questo caso sono limitate a
          quelle più parlate, la qual cosa esclude (…) spesso le lingue parlate dai migranti (ad eccezione dell’arabo e
          di pochi altri casi). Abbiamo pensato di implementare un tool esterno nella piattaforma per offrire l’intera
          serie di assistenti linguistici possibili. Ricordiamo che nel caso dello speech-to-speech, la corretta e
          chiara pronuncia delle parole è fondamentale, così come l’utilizzo di termini non eccessivamente tecnici.
          Questa funzione è infatti prevista per i casi di urgenza, dove una comunicazione di non eccellente qualità è
          comunque meglio dell’assenza di comunicazione!
        </p>

        <h4>Norme di scrittura e di sintesi</h4>
        <p>
          Raccomandiamo di scrivere in modo quanto più possibile chiaro e sintetico e limitarsi alle comunicazioni che
          hanno carattere di urgenza o di immediata necessità per evitare sovraccarichi per i traduttori! Esiste un
          (limitato) spazio per note e osservazioni nel caso in cui siano necessarie. Evitare per ovvie ragioni
          l’indicazione di dati personali e altri dati sensibili. La piattaforma non è responsabile dei contenuti
          riportati all’interno dei documenti.
        </p>
        <p>
          Se la documentazione da tradurre contiene dati sensibili o se il documento è già stato scritto da altri e non
          può essere abbreviato, semplificato, ecc. raccomandiamo di segnalare – quando possibile – le parti
          prioritarie, le eventuali problematiche di interpretazione, ecc.
        </p>

        <h4>Tipologie di testi</h4>
        <p>
          Abbiamo ritenuto di non porre limitazioni alle tipologie di testi da tradurre. Può trattarsi di argomenti
          legali, sanitari, medici, ecc. L’importante, però, è che questi testi siano di immediata utilità per gli
          operatori e per i migranti. La piattaforma non è pensata per testi di notevole lunghezza (diverse cartelle),
          di notevole complessità.
        </p>
        <p>
          È fondamentale interpretare le funzioni della piattaforma come essenziali per il lavoro degli operatori e per
          la salvaguardia, la tutela e la sicurezza dei migranti. La piattaforma non sostituisce il servizio di
          traduzione dei molti migranti, mediatori culturali o meno, che con il loro lavoro assicurano alle
          organizzazioni e agli altri migranti un servizio fondamentale e a se stessi la possibilità di sopravvivere con
          un lavoro di grande rilevanza!
        </p>

        <h4>Principio della compartecipazione</h4>
        <p>
          La piattaforma vuole ispirarsi ai principi di gratuità e universalità. Si tratta di principi che richiedono la
          compartecipazione attiva di tutti coloro che la utilizzano e che necessita del loro supporto: per segnalare
          eventuali irregolarità di funzionamento, per indicare l’assenza di alcune lingue (che provvederemo a ricercare
          e inserire), ecc. La piattaforma funziona grazie anche al comportamento corretto e proattivo degli utenti. In
          particolare, nel caso delle organizzazioni, è importante che queste compartecipino diffondendo ai propri
          contatti l’informazione che questa piattaforma esiste ed è disponibile per tutti.
        </p>
        <p>
          La piattaforma, infine, funziona soprattutto grazie al supporto linguistico delle molte persone che hanno
          dichiarato la loro disponibilità a fornire gratuitamente la loro conoscenza della lingua di origine.
        </p>

        <h4>Il database dei traduttori: uno strumento fondamentale per ringraziarli fattivamente del loro lavoro</h4>
        <p>
          Nella piattaforma troverete una sezione che include un elenco dei traduttori che operano sulla piattaforma. Il
          database integra attualmente una funzione di ricerca per lingue e per ordine alfabetico. Si tratta di uno
          spazio in cui i traduttori si presentano e parlano di sé e delle loro conoscenze. Abbiamo pensato a questo
          spazio come a una possibilità di incontro fra le organizzazioni che utilizzano la piattaforma e le persone che
          traducono: per necessità di traduzione continuative, per testi di elevata lunghezza o particolarmente
          specialistici, le organizzazioni possono contattare i traduttori e creare un legame indipendente dalla
          piattaforma offrendo loro una possibilità di lavoro e di maggiore integrazione.
        </p>
        <hr class="btn-outline-primary" />
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "Compliance",
  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped>
.jumbotron {
  background-image: url("/img/bg-home.png");
  background-position-y: 80%;
}
</style>
